const Config = {
  apiUrl: "https://dashboard.couleursharmonie.be/site",
  token: "V8MtOWAQpwsw4X1MG27ITs74",
}

export default Config
